// usersRoutes
import React from "react";
import ManageDealers from "../manage-dealers/ManageDealers";
import UserCreation from "../../features/users/UserCreation";
import UserDetail from "../../features/users/UserDetail";

// settingsRoutes
import Settings from "../settings/Settings";
import LevelSettings from "../settings/levels/LevelSettings";
import AvailableServices from "../settings/services/AvailableServices";
import AvailableSuppliers from "../settings/Suppliers/AvailableSuppliers";
import ProductTypes from "../settings/Suppliers/ProductTypes";
import BannerSettings from "../settings/Banner/BannerSettings";
import EditSupplier from "../settings/Suppliers/EditSupplier";
import EditProduct from "../settings/Suppliers/products/EditProduct";
import AdminSupplier from "../settings/Suppliers/AdminSupplier";

// trainingRoutes
import TrainingModules from "../training/TrainingModules";
import TrainingContent from "../training/TrainingContent";
import TrainingMarks from "../training/TrainingMarks";
import TrainingContentViewer from "../training/TrainingContentViewer";
import TrainingAttempt from "../training/TrainingAttempt";

// alertsRoutes
import GlobalAlerts from "../global-alerts/GlobalAlerts";
import AlertsList from "../global-alerts/AlertsList";
import CreateAlert from "../global-alerts/CreateAlert";
// baseRoutes
import SelectDash from "../dealercomps/agent-dashboard/SelectDash";
import Supplier from "../dealercomps/agent-dashboard/dash-components/Supplier";
import ImportFibreReport from "../import-reports/ImportFibreReport";
import AdminDrilldown from "../reports/AdminDrilldown";
import AllUsers from "../dealercomps/reports/AllUsers";
import AllDealers from "../manage-dealers/dealer-lists-r/AllDealers";
import DealersChildDownstream from "../dealercomps/subdealers/DealersChildDownstream";
import DealerAgents from "../manage-dealers/dealer-detail-r/DealerAgents";
import DealerApprovals from "../manage-dealers/approvals/DealerApprovals";
import ApprovalDetail from "../manage-dealers/approvals/ApprovalDetail";
import SadvAgentCsvImport from "../shared/SadvAgentCsvImport";
import AdminSection from "../admin-section/AdminSection";
import OrderOverride from "../admin-section/order-override/OrderOverride";
import EditSalesNote from "../admin-section/EditSalesNote";
import AdminSalesView from "../admin-section/admin-sales-leads/AdminSalesView";
import UpdatePassword from "../authenticate/UpdatePassword";
import EmailVerification from "../manage-dealers/EmailVerification";
import PhoneVerification from "../manage-dealers/PhoneVerification";
import ProfilePage from "../user-profile/ProfilePage";
import CommissionsPage from "../admin-section/finance/commissions/CommissionsPage";
import AdminAgentAssistFullView from "../admin-section/admin-agent-assist/AdminAgentAssistFullView";
import RicaPage from "../rica/RicaPage";

import PrivateRoute from "./PrivateRoute";

export const userRoutes = [
  { path: "/manage-dealers", exact: true, component: ManageDealers },
  { path: "/users/create", exact: true, component: UserCreation },
  { path: "/user-detail/:dealerId", component: UserDetail },
];

export const settingsRoutes = [
  { path: "/settings", exact: true, component: Settings },
  { path: "/settings/levels", component: LevelSettings },
  { path: "/settings/services", component: AvailableServices },
  { path: "/settings/suppliers", component: AvailableSuppliers },
  { path: "/settings/product-types", component: ProductTypes },
  { path: "/settings/banner", component: BannerSettings },
  { path: "/addSupplier", exact: true, component: EditSupplier },
  { path: "/edit-supplier/:id/", component: EditSupplier },
  { path: "/edit-product/:supplier/:product/", component: EditProduct },
  { path: "/add-product/:supplier/", component: EditProduct },
  { path: "/admin/Supplier/:id/", component: AdminSupplier },
];

export const trainingRoutes = [
  { path: "/training", exact: true, component: TrainingContentViewer },
  { path: "/training-modules", exact: true, component: TrainingModules },
  {
    path: "/training-content/:id/:name",
    exact: true,
    component: TrainingContent,
  },
  { path: "/training-marks/:id/:name", exact: true, component: TrainingMarks },
  { path: "/training-attempt/:id", exact: true, component: TrainingAttempt },
];

export const alertsRoutes = [
  { path: "/alerts", exact: true, component: GlobalAlerts },
  { path: "/alerts/view", exact: true, component: AlertsList },
  { path: "/alerts/create", exact: true, component: CreateAlert },
  { path: "/alerts/:id/edit", exact: true, component: CreateAlert },
];

export const baseRoutes = [
  { path: "/", exact: true, component: SelectDash },
  { path: "/Supplier/:supplierId", exact: true, component: Supplier },
  { path: "/import-fibre-activity", component: ImportFibreReport },
  {
    path: "/dd-report-admin/:type/:rank/:dealerId/:year/:month/:network",
    exact: true,
    component: AdminDrilldown,
  },
  { path: "/all-users", exact: true, component: AllUsers },
  { path: "/all-dealers", component: AllDealers },
  {
    path: "/child-dealer-downstream/:dealerId",
    component: DealersChildDownstream,
  },
  { path: "/dealer-agents/:dealerId", component: DealerAgents },
  { path: "/approvals", component: DealerApprovals },
  { path: "/approval-detail/:id", component: ApprovalDetail },
  {
    path: "/import-sadv-agents-csv",
    exact: true,
    component: SadvAgentCsvImport,
  },
  { path: "/admin-section", exact: true, component: AdminSection },
  { path: "/order-override", exact: true, component: OrderOverride },
  { path: "/edit-sales-note", exact: true, component: EditSalesNote },
  { path: "/sales-leads-admin-view", exact: true, component: AdminSalesView },
  { path: "/update-password", exact: true, component: UpdatePassword },
  {
    path: "/verify-email/:verificationId",
    exact: true,
    component: EmailVerification,
  },
  { path: "/verify-phone", exact: true, component: PhoneVerification },
  { path: "/profile", exact: true, component: ProfilePage },
  { path: "/commissions", exact: true, component: CommissionsPage },
  {
    path: "/admin-agent-assist",
    exact: true,
    component: AdminAgentAssistFullView,
  },
  { path: "/rica", exact: true, component: RicaPage },
  {
    path: "/admin-agent-support",
    exact: true,
    component: AdminAgentAssistFullView,
  },
];

const allRoutes = [
  ...baseRoutes,
  ...userRoutes,
  ...settingsRoutes,
  ...trainingRoutes,
  ...alertsRoutes,
];

/**
 * Routes component renders all the private routes for the application.
 *
 * @returns {React.Element} The rendered routes.
 */
export default function Routes() {
  return (
    <>
      {allRoutes.map(({ path, exact, component }) => (
        <PrivateRoute
          key={path}
          path={path}
          exact={exact}
          component={component}
        />
      ))}
    </>
  );
}
